/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Rejected_HintInputs */

const vi_einvoice_rejected_hint = /** @type {(inputs: Einvoice_Rejected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ quan thuế từ chối cấp mã. Nhờ kế toán kiểm tra và xử lý trên MISA rồi kiểm tra lại trạng thái.`)
};

/**

* @param {Einvoice_Rejected_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_rejected_hint = /** @type {((inputs?: Einvoice_Rejected_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Rejected_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_rejected_hint(inputs)
});